import React from "react";
import { Hyperlink, HyperlinkProps } from "../../../Links/Hyperlink/Hyperlink";
import { Stack } from "../../../Stacks/Stack/Stack";
import { OperationalContent, OperationalContentProps } from "../shared/OperationalContent";
import { ListItemColumnProps } from "../shared/props";

interface BaseHyperlinkColumnProps extends ListItemColumnProps {
    /**
     * Array of Hyperlink props to create <HyperLink /> elements.
     */
    readonly hyperlinks: readonly HyperlinkProps[];
}

export type HyperlinkColumnProps = BaseHyperlinkColumnProps & OperationalContentProps;

export const HyperlinkColumn: React.FC<HyperlinkColumnProps> = ({
    hyperlinks,
    disabled,
    operationalData
}) => (
    <Stack
        horizontal={true}
        childrenGap="16"
        wrap={true}
    >
        <OperationalContent
            operationalData={operationalData}
        >
            {hyperlinks.map((hyperlinkProps, index) => <Hyperlink {...hyperlinkProps} disabled={disabled ?? hyperlinkProps.disabled} key={index} />)}
        </OperationalContent>
    </Stack>
);
